import FormattedList from 'I18n/components/FormattedList';
import PropertyNameLabel from 'automation-ui-management/components/flp/PropertyNameLabel';
import { jsx as _jsx } from "react/jsx-runtime";
const SensitivePropertyNamesList = ({
  flpRejectionReasons
}) => {
  return /*#__PURE__*/_jsx(FormattedList, {
    children: flpRejectionReasons.map(reason => /*#__PURE__*/_jsx("b", {
      children: /*#__PURE__*/_jsx(PropertyNameLabel, {
        objectTypeId: reason.objectTypeId,
        propertyName: reason.propertyName
      })
    }, reason.propertyName))
  });
};
export default SensitivePropertyNamesList;